__turbopack_context__.v({
  "Careers": "Careers-module-sass-module__Zk8gHW__Careers",
  "Count": "Careers-module-sass-module__Zk8gHW__Count",
  "Reset": "Careers-module-sass-module__Zk8gHW__Reset",
});
